// @ts-strict-ignore
import { useEffect, useState } from 'react';

import { TileCarouselResult } from 'api/types/shared.types';
import { JobFunction } from 'utils/constants';
import { log } from 'utils/logging';
import { getRecommendedJobs } from 'utils/search/getRecommendedJobs';

/*
 * Fetch recommended jobs
 */
export function useRecommendedJobs(
  searchLocation: Partial<SearchLocation> &
    Pick<SearchLocation, 'latitude' | 'longitude'>,
  options?: {
    onlyWithLogo: boolean;
    jobFunction?: JobFunction | null;
    jobTitle?: string;
    familyId?: string;
    query?: string;
  }
) {
  const { onlyWithLogo, jobFunction, familyId } = options;

  const [data, setData] = useState<TileCarouselResult[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    getRecommendedJobs({
      searchLocation,
      options: {
        onlyWithLogo,
        jobFunction,
        familyId,
      },
      searchOptions: { distinct: true },
    })
      .then((jobs) => {
        setData(
          jobs.map((job) => ({
            city: job.city,
            id: job.objectID,
            logo: job.logo,
            orgName: job.orgName,
            name: job.name,
            state: job.state,
            url: job.url,
          }))
        );
      })
      .catch((e) => {
        setError(e);
        log.error(e);
      })
      .finally(() => setIsLoading(false));
  }, [searchLocation, onlyWithLogo, jobFunction, familyId]);

  return { data, isLoading, error };
}
